module.exports = __webpack_public_path__ + "img/ai_btn.fe772e49.svg";